// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const RightNav: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18">
            <path
                fill="currentColor"
                d="M7.83111415,17.6176315 L0.343358651,9.8443236 C0.114435318,9.60780025 0,9.30428339 0,9.00051057 C0,8.69683998 0.114488014,8.39296494 0.343359449,8.15669754 L7.83111495,0.383389651 C8.30858361,-0.108834615 9.10314367,-0.129546327 9.60651312,0.335445729 C10.1134411,0.802099903 10.1313361,1.58224365 9.65556812,2.07114368 L2.93699566,9.00063855 L9.65556812,15.9301334 C10.1314144,16.4191364 10.1134148,17.195853 9.60651312,17.6658314 C9.10785276,18.1290333 8.31250785,18.1085776 7.83111495,17.6176315 L7.83111415,17.6176315 Z"
                transform="matrix(-1 0 0 1 10 0)"
            />
        </svg>
    );
};

export default React.memo(RightNav);
